import { Component, OnInit, OnDestroy } from '@angular/core';
import { ConfigService } from '../../helpers/config.service';
import { DataServiceService } from '../../helpers/data.service';
import { Router, ActivatedRoute } from '@angular/router';
import {WindowRefService} from "../../helpers/windowref.service";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";

@Component({
    selector: 'app-netflix-coupon-step3',
    templateUrl: './netflix-coupon-step3.component.html',
    styleUrl: './netflix-coupon-step3.component.scss',
    standalone: false
})
export class NetflixCouponStep3Component implements OnInit, OnDestroy {
  csData:any = {};
  showCsData:boolean = true;
  showVideo:boolean = false;
  showConfetti:boolean = false;
  componentDestroyed: Subject<boolean> = new Subject();
  action: string = 'link';
  constructor(public data:DataServiceService, public cs: ConfigService, private router: Router,
              private activatedRoute: ActivatedRoute, private winRef: WindowRefService, ){
    this.data.setIsCouponLastStep(false);
    this.data.setHeaderMenuSelection('11');
    this.getCsData();
  }
  ngOnInit(): void {
    this.winRef.reportGtagEventNew('pageViewStep3');
    this.activatedRoute.queryParams.pipe(takeUntil(this.componentDestroyed)).subscribe(params => {
      if (params['action']) {
        this.action =params['action'];
      }
    });
    this.openConfetti();
    document.body.scrollTop = 0;
    this.getCsData();
  }

  ngOnDestroy(): void {
    this.componentDestroyed.next(true);
    this.componentDestroyed.complete();
  }

  async getCsData(): Promise<void> {
    this.csData = {};
    this.showCsData = true;
    await this.cs.getConfigurations('netflix', 'en');
    this.data.setCsObj(this.cs);
    this.csData = this.cs;
    setTimeout(() => {
      this.showCsData = false;
    }, 100);
  }

  linkAccount(): void {
    this.winRef.reportGtagEventNew('pageViewStep4');
    this.router.navigate(['/n']);
  }

  openConfetti():void {
    setTimeout(()=>{
      this.showConfetti = true;
    }, 2000);
    setTimeout(()=>{
      this.showVideo = true;
    }, 9000);
  }
}
